import noop from 'lodash/noop';
import { isCleanExit } from '@selectors/matches';

export const onbeforeunload = ({ getState }) => () =>
  isCleanExit(getState())
    ? noop()
    : 'Perderá los cambios en el pronóstico, salir?';
